import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateChatSettingsEnableChat as EnableChatMutation,
    UpdateChatSettingsEnableChatVariables as EnableChatMutationVariables,
    ChatSettingsEnableChatInput,
} from 'nutshell-graphql-types';

import ENABLE_CHAT from '../mutations/update-chat-settings-enable-chat.graphql';
import GET_CHAT_SETTINGS from '../queries/get-chat-settings.graphql';

export const useUpdateEnableChat = (): {
    enableChat: (input: ChatSettingsEnableChatInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [enableChatMutation, {loading, error}] = useMutation<
        EnableChatMutation,
        EnableChatMutationVariables
    >(ENABLE_CHAT);

    return {
        enableChat: (input: ChatSettingsEnableChatInput) => {
            return enableChatMutation({
                variables: {input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    chatSettingsEnableChat: {
                        __typename: 'ChatSettingsEnableChatPayload',
                        isChatEnabled: input.isChatEnabled,
                    },
                },
                update: (proxy, {data}) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_CHAT_SETTINGS,
                    });

                    if (
                        !cacheResult ||
                        // @ts-expect-error
                        !cacheResult.chatSettings ||
                        !data ||
                        !data.chatSettingsEnableChat
                    ) {
                        return;
                    }

                    proxy.writeQuery({
                        query: GET_CHAT_SETTINGS,
                        data: {
                            chatSettings: {
                                // @ts-expect-error
                                ...cacheResult.chatSettings,
                                isChatEnabled: data.chatSettingsEnableChat.isChatEnabled,
                            },
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
